import { SxProps, Theme } from '@mui/material/styles';
import { EChartsReactProps } from 'echarts-for-react';
import dynamic from 'next/dynamic';
import { CSSProperties, FC, ForwardedRef, forwardRef } from 'react';

import { HBChartRootStyle } from './HBChart.styles';

const EChart = dynamic(() => import('echarts-for-react'), {
  ssr: false,
}) as FC<EChartsReactProps>;

export interface HBChartProps extends Omit<EChartsReactProps, 'ref'> {
  sx?: SxProps<Theme>;
  chartStyle?: CSSProperties;
  chartType?: 'line' | 'bar' | 'pie' | 'area';
  chartColors?: string[];
  chartTheme?: 'dark' | 'light';
  onCategoryClick?: (params: any, chart: any) => void;
}

export const HBChart = forwardRef(
  <T extends HTMLDivElement>(
    {
      sx,
      chartStyle,
      chartType = 'line',
      chartColors,
      option,
      chartTheme,
      onCategoryClick,
      ...props
    }: HBChartProps,
    ref: ForwardedRef<T>,
  ) => {
    return (
      <HBChartRootStyle ref={ref} sx={sx}>
        <EChart
          theme={chartTheme}
          option={option}
          style={{ height: '100%', width: '100%', ...chartStyle }}
          lazyUpdate
          onEvents={{
            legendselectchanged: (params: any, myChart: any) => {
              onCategoryClick?.(params, myChart);
            },
          }}
          {...props}
        />
      </HBChartRootStyle>
    );
  },
);

HBChart.displayName = 'HBChart';
